import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Modal from './RespModal';
import cross from '../../Assets/ContainerStatus/Assets_Desktop/close-icon.svg';
import Button from '../Shared/Button';
import '../../css/Shared/ManageProfileModal.css';
import hrLine from '../../Assets/ContainerStatus/Assets_Desktop//horizontal-dotted-line.svg';
import indicatorActive from "../../Assets/ContainerStatus/Assets_Desktop/indicator-active.svg";
import hrSolidLine from '../../Assets/ContainerStatus/Assets_Desktop/horizontal-solid-line.svg';
import arrow from "../../Assets/ContainerStatus/Assets_Desktop/arrow-right-medium.svg";
import disableRadio from "../../Assets/ContainerStatus/Assets_Desktop/radio-unchecked-disabled.svg";
import enableRadio from '../../Assets/ContainerStatus/Assets_Desktop/radio-unchecked.svg';
import checkRadio from '../../Assets/ContainerStatus/Assets_Desktop/radio-checked-green.svg';
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { AES, enc } from 'crypto-js';
import { successManageProfile } from "../../Redux/_actions/manageProfile.action";
import { connect } from 'react-redux';
let selectedProfileIndex;

// var checkProfile = 0;
// var profileApproved = false;
// var profilePending = false;
// var profileApprovedName = '';


    

 
var approvedRoleType='';
var reqOrResPending=false;
var reqOrResApproved=false;




function ManageProfileModal(props) {
    const dispatch = useDispatch();
    const location = useLocation();
    let history = useHistory();
    const userProfileDataR = props.userProfileDataRFun;
    //useSelector(state => JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8)));
  //  const userProfileDataR = useSelector(state => state.userProfileInfoReducer.data);
    const manageProfileDataR = useSelector(state => state.manageProfileReducer.data);
    const [rolesData, setRolesData] = useState();
    const [selectedRadioButton, setSelectedRadioButton] = useState('');

    // let [checkProfile, setCheckProfile] = useState(0);
    // let [profileApproved, setProfileApproved] = useState(false);
    // let [profilePending, setProfilePending] = useState(false);
    // let [profileApprovedName, setProfileApprovedName] = useState("");
const [reqPresent, setReqPresent] = useState(false);
const [resPresent, setResPresent] = useState(false);

    useEffect(() => {

        var requesterPresent = false;
 var respondentPresent = false;
 var requesterApproved = false;
 var respondentApproved = false;
 var requesterIndex = -1;
 var respondentIndex = -1;

        let rolesData1 = userProfileDataR?.profileRoles.filter(role => !["Preview", "preview"].includes(role.roleType));
        
        setRolesData(rolesData1);
        if (['Premium', 'premium'].includes(userProfileDataR?.userType) ||
            ['Preview', 'preview'].includes(userProfileDataR?.userType) && ['Driver', 'driver'].includes(manageProfileDataR?.selectedProfileType)
            && ['Approved', 'approved', 'Approved'].includes(manageProfileDataR.selectedProfileStatus)
        ) {
            setSelectedRadioButton(manageProfileDataR?.selectedProfile);
        }


        userProfileDataR?.profileRoles?.forEach((md, index) => {
 if (md.roleType.toLowerCase() == 'requester') {
 requesterPresent = true;
 setReqPresent(true);
 requesterIndex = index;
 requesterApproved = md.profileStatus.toLowerCase() == 'approved';


 
 // this.setState({
 approvedRoleType = requesterApproved ? 'requester' : approvedRoleType;
 reqOrResPending = reqOrResPending || md.profileStatus.toLowerCase() == 'pending';
 reqOrResApproved = reqOrResApproved || requesterApproved;
 // this.state.reqOrResApproved || requesterApproved
 
 // })
 }
 else if (md.roleType.toLowerCase() == 'respondent') {
setResPresent(true);
 respondentPresent = true;
 respondentIndex = index;
 respondentApproved = md.profileStatus.toLowerCase() == 'approved';
 
 // this.setState({
 approvedRoleType = respondentApproved ? 'respondent' : approvedRoleType;
 
 reqOrResPending = reqOrResPending || md.profileStatus.toLowerCase() == 'pending';
 // reqOrResApproved : this.state.reqOrResApproved || respondentApproved
 reqOrResApproved = reqOrResApproved || respondentApproved;
 
 // })
 
 }
 });



// // for check requester and respondent profile staus 
//         userProfileDataR?.profileRoles?.map((role,i) => {
//             if(role.roleType == "Requester"){
//                 setCheckProfile(checkProfile++);
//                  if(['Pending', 'pending'].includes(role.profileStatus)){
//                      setProfilePending(true);
//                      //profilePending = true;
//                    //  alert('req pend')
                  
//                  }else if(['Approved', 'approved'].includes(role.profileStatus)){
//                      setProfileApproved(true);
//                     // profileApproved = true;
//                     setProfileApprovedName( role.roleType);
//                 //     profileApprovedName = role.roleType;
//                    //  alert('req app')
//                  }
//             }
//             else if(role.roleType == "Respondent"){
//                 setCheckProfile(checkProfile++);
//                 if(['Pending', 'pending'].includes(role.profileStatus)){
//                     setProfilePending(true);
//               //   profilePending = true;
//                 // alert('res pen')
                
//              }else if(['Approved', 'approved'].includes(role.profileStatus)){
//                 setProfileApproved(true);
//                  //profileApproved = true;
//                  setProfileApprovedName( role.roleType);
//                 // profileApprovedName = role.roleType;
//                 // alert('res app')
//              }
//             }
//          })
    }, [])
    const checkProfileStatus = (type, profileStatus) => {
      
        if (!['Not Completed','Not completed', 'not completed', 'NOT COMPLETED'].includes(profileStatus)) {
            history.push(`/profileActivity/${type}`);
        }
    }
    const selectProfile = (i, selectedRoleType, profileStatus, selectedRoleName) => {
        if (['Premium', 'premium'].includes(userProfileDataR?.userType) && ['Approved', 'approved', 'APPROVED'].includes(profileStatus)
            || ['Preview', 'preview'].includes(userProfileDataR?.userType) && ['Driver', 'driver'].includes(selectedRoleType)
            && ['Approved', 'approved', 'APPROVED'].includes(profileStatus)) {
            setSelectedRadioButton(i);
            const pData = {
                selectedProfile: i,
                selectedProfileType: selectedRoleType,
                selectedProfileStatus: profileStatus,
                selectedProfileRoleName: selectedRoleName
            }
            dispatch(successManageProfile(pData));
          
            props.setModalCloseFlag(false);
          
            if (location.pathname === '/home') {
                history.push({
                    pathname: '/',
                });
            }
            else {
                history.push({
                    pathname: '/home',
                });
            }
        }
    }
    const viewProfile = (index,roleType) => {

        if (reqPresent && resPresent && reqOrResPending && reqOrResApproved && approvedRoleType == roleType.toLowerCase()) {
            //display modal for the same
            
            //Unable to select profile, Requestor, Respondent or both are not yet approved.
            // alert('Unable to select profile, Requestor/Respondent or both are not yet approved');
            
            }
            else {
                rolesData.find((name) => {
                    if (name.roleType === rolesData[index].roleType && name.roleName === rolesData[index].roleName) {
                        history.push({
                            pathname: `/viewProfile/${name.roleId}/${name.roleType}/${name.roleName}/${name.profileStatus}`,
                        });
                    }
                });
            }



    //     console.log("roleName--", roleType)
    //     if((checkProfile == 2 && profilePending && profileApproved && (profileApprovedName == roleType))){
    //         alert("profile not approved  for res and req");
    //      }
    //      else{
    //     rolesData.find((name) => {
    //         if (name.roleType === rolesData[index].roleType && name.roleName === rolesData[index].roleName) {
    //             history.push({
    //                 pathname: `/viewProfile/${name.roleId}/${name.roleType}/${name.roleName}/${name.profileStatus}`,
    //             });
    //         }
    //     });
    // }
    }
    const onAddProfile = () => {
        history.push('/addProfile');
    }
    return (
        <Modal hasOpen={props.hasOpen}>
            <div className="manageProfileouterModal">
                <div className='modalcrossProfile'>
                    <img src={cross} onClick={props.onCloseModal} width="30" height="30" class="d-inline-block align-top" alt="" loading="lazy" />
                </div>
                <p className='modalheading'>Manage your profiles</p>
                <img alt="hr" src={hrLine} className="hrLine" />
                <div className="stepsOuterBlock">
                    <div className="stepsBlock">
                        <p className="step">Step 1</p>
                        <p className="step">Step 2</p>
                        <p className="step">Step 3</p>
                    </div>
                    <div>
                        <img alt="indicator-active" src={indicatorActive} />
                        <img alt="horizontal-solid-line" src={hrSolidLine} className="hrSolidLine" />
                        <img alt="indicator-active" src={indicatorActive} />
                        <img alt="horizontal-solid-line" src={hrSolidLine} className="hrSolidLine" />
                        <img alt="indicator-active" src={indicatorActive} />
                    </div>
                    <div className="stepBottomBlock">
                        <p className="steps" id="step1">Submit profile for approval</p>
                        <p className="steps" id="step2">Approved by admin</p>
                        <p className="steps" id="step3">Pay subscription fees*</p>
                    </div>
                </div>
                <div className="noteDiv">
                    <div className="sethr"><img alt="hr" src={hrLine} className="notehr" /></div>
                    <div className="noteContainer"><p className="noteText">*Not required for Drivers</p></div>
                    <div className="sethr"><img alt="hr" src={hrLine} className="notehr" /></div>
                </div>
                <div>
                    {rolesData?.map((name, index) =>
                        <div className='cardContainer' key={index}>
                            <div className="leftPart">
                                <div className='upperPart'>
                                    <div className="roles">
                                        <small className='roleType'>{name.roleType}</small><br />
                                        <small className='roleName'>{name.roleName}</small>
                                    </div>
                                    <div className='statusDiv'>
                                        <small className='statustext'>Status</small><br />
                                        <div className="statusCheck" onClick={() => checkProfileStatus(name.roleType, name.profileStatus)}>
                                            <small className='status' style={{ color: ["Pending", "pending", "PENDING"].includes(name.profileStatus) ? "#FF7309" : (['Not Completed','Not completed', 'not completed', 'NOT COMPLETED', 'rejected', 'Rejected', 'REJECTED'].includes(name.profileStatus) ? " #841300" : "#199D00") }}>{name.profileStatus}</small>
                                            {['Not Completed','Not completed', 'not completed', 'NOT COMPLETED'].includes(name.profileStatus) ? null :
                                                <img src={arrow} id='profileCheck' width="6" height="12" class="d-inline-block align-top" alt="" loading="lazy"
                                                    onClick={props.profileCheck}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                                <hr className='modalhr' />
                                <div className='belowPart' onClick={() => viewProfile(index, name.roleType)}>
                                    <small className='profile' >Profile</small>
                                    <img src={arrow} id="profileArrow" width="8" height="16" class="d-inline-block align-top" alt="" loading="lazy" />
                                </div>
                            </div>
                            {['Premium', 'premium', 'PREMIUM'].includes(userProfileDataR?.userType) &&
                                <div className={(['Not Completed','Not completed', 'not completed', 'NOT COMPLETED', 'rejected', 'Rejected', 'REJECTED'].includes(name.profileStatus) || ["Pending", "pending", "PENDING"].includes(name.profileStatus)) ? 'Disableimgsidepartition' : 'sidepartition'}>
                                    <img src={(['Not Completed','Not completed', 'not completed', 'NOT COMPLETED', 'rejected', 'Rejected', 'REJECTED',
                                        "Pending", "pending", "PENDING"].includes(name.profileStatus)) ? disableRadio : (selectedRadioButton === index ? checkRadio : enableRadio)}
                                        key={index} onClick={() => selectProfile(index, name.roleType, name.profileStatus, name.roleName)}
                                        id="ProfileCheckImage"
                                        width="25" height="25" class="d-inline-block align-top" alt="" loading="lazy"
                                    />
                                </div>
                            }
                            {['Preview', 'preview', 'PREVIEW'].includes(userProfileDataR?.userType) &&
                                <div className={(['Not Completed','Not completed', 'not completed', 'NOT COMPLETED', 'rejected', 'Rejected', 'REJECTED'].includes(name.profileStatus) || ["Pending", "pending", "PENDING"].includes(name.profileStatus)
                                    || ['Requester', 'requester', 'REQUESTER', 'RESPONDENT', 'Respondent', 'respondent'].includes(name.roleType)) ? 'Disableimgsidepartition' : 'sidepartition'}>
                                    <img src={(['Not Completed','Not completed', 'not completed', 'NOT COMPLETED', 'rejected', 'Rejected', 'REJECTED',
                                        "Pending", "pending", "PENDING"].includes(name.profileStatus) || ['Requester', 'requester', 'REQUESTER', 'RESPONDENT', 'Respondent', 'respondent'].includes(name.roleType)) ? disableRadio : (selectedRadioButton === index ? checkRadio : enableRadio)}
                                        key={index} onClick={() => selectProfile(index, name.roleType, name.profileStatus, name.roleName)}
                                        id="ProfileCheckImage"
                                        width="25" height="25" class="d-inline-block align-top" alt="" loading="lazy"
                                    />
                                </div>
                            }
                        </div>
                    )}
                </div>
                <Button
                    type="button"
                    className='modalbtn'
                    onClick={() => onAddProfile()}
                    id="buttonmodal"
                >Add Profile
            </Button><br /><br />
            </div>
        </Modal>
    );
}
function mapStateToProps(state) {
    if (state.userProfileInfoReducer.data) {
      return {
   //  loginDataRFun :  JSON.parse(AES.decrypt(state.authentication.user, 'TPT_CARGO_CONNECT').toString(enc.Utf8)),
      userProfileDataRFun : JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8)),
        
      }
    }
}
export default connect(mapStateToProps)(ManageProfileModal);
